import React from 'react';
import { Card } from '@mui/material';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface GlassEmptyStateProps {
  message: string;
}

const cardSx = {
  alignItems: 'center',
  backdropFilter: 'blur(6px)',
  background: 'linear-gradient(135deg, rgba(255,255,255,0.16), rgba(255,255,255,0.06))',
  border: '1px solid rgba(255,255,255,0.24)',
  borderRadius: 2,
  boxShadow: '0 10px 24px rgba(6, 24, 44, 0.24)',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  minHeight: 56,
  paddingX: 1.2,
  paddingY: 1,
  width: '100%',
  WebkitBackdropFilter: 'blur(6px)',
};

export const GlassEmptyState: React.FC<GlassEmptyStateProps> = ({ message }) => {
  return (
    <Card sx={cardSx}>
      <CustomTypography sx={{ color: '#f5f8ff' }}>{message}</CustomTypography>
    </Card>
  );
};
